<template>
  <Button
    :class="computedClass"
    :type="type"
    :size="size"
    :variant="variant"
    :loading="loading"
    :disabled="disabled"
    :aria-disabled="disabled"
    :aria-busy="loading"
    @click.prevent="submitStep"
  >
    {{ value }}
  </Button>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

interface Errors {
  [key: string]: any;
}

export default {
  name: 'RouteStepperNextButton',
  components: { Button },
  inject: {
    navigateToNextStep: {
      default: () => {},
    },
  },
  inheritAttrs: false,
  props: {
    stepData: {
      type: Object,
      default: () => ({}),
    },
    draftData: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: 'submit',
    },
    value: {
      type: String,
      default: 'Next',
    },
    size: {
      type: String,
      default: 'medium',
    },
    validate: {
      type: Function,
      default: () => ({}),
      validator(fn: Function) {
        try {
          const result = fn();
          return typeof fn === 'function' && typeof result === 'object' && result !== null && !Array.isArray(result);
        } catch (e) {
          console.warn('RouteStepperNextButton validate function must return an errors object.');
          return false;
        }
      },
    },
  },
  computed: {
    computedClass() {
      return this.$attrs.class || 'w-full md:max-w-max';
    },
    injectedNavigateToNextStep(): Function {
      // this is a fallback to make testing easier, otherwise we would need to mock the injected function for every test
      return this.navigateToNextStep || (() => {});
    },
  },
  mounted() {
    // emit reference to this component to the RouteStepper for validation
    this.$root.$emit('register-next-button', this);
  },
  methods: {
    submitStep(): boolean {
      const errors: Errors = this.validate();
      const hasErrors: boolean = Object.keys(errors).length > 0;
      this.$emit('errors', errors);

      if (!hasErrors) {
        this.injectedNavigateToNextStep(this.stepData, this.draftData);
      }

      return !hasErrors;
    },
  },
};
</script>
